import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=528dcdec&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528dcdec')) {
      api.createRecord('528dcdec', component.options)
    } else {
      api.reload('528dcdec', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=528dcdec&", function () {
      api.rerender('528dcdec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Carousel.vue"
export default component.exports